// AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { auth } from '../config/firebase-config';
import axios from "axios";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(window.localStorage.getItem('auth') === 'true');

  useEffect(() => {
    const AuthStateChanged = auth.onAuthStateChanged(async (userCred) => {
      if (userCred) {
        setUser(userCred);
        try {
          const t = await userCred.getIdToken();
          setToken(t);
          console.log("posted");
          const res = await axios.post(
            "/api/saveUserData",
            {
              displayName: userCred.displayName
            },
            {
              headers: {
                Authorization: "Bearer " + t,
                "Content-Type": "application/json"
              }
            }
          );
          console.log("Response:", res);
        } catch (err) {
          console.error(err);
        }
        window.localStorage.setItem('auth', 'true');
        console.log("logged in");
      } else {
        setUser(null);
        window.localStorage.setItem('auth', 'false');
        setToken('');
      }
    });
    return AuthStateChanged;
  }, []);

  const loginWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Google Sign-In failed:", error);
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Google Sign-In failed:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
